export const generateId = (): string => {
  if ("crypto" in window && "randomUUID" in window.crypto) {
    return window.crypto.randomUUID();
  }

  return Math.random().toString(36).slice(2, 11);
};

